module.exports = __webpack_public_path__ + "static/media/review3.27df04d9.webp";